export default {
    excess: 'Assurance responsabilité',
    security: 'Dépôt de garantie',
    fuel_policy: 'Politique de carburant',
    like_for_like: 'Réservoir similaire',
    full_to_full: 'Réservoir plein',
    mileage: 'Miles : {mileage} miles par location',
    unlimited_mileage: 'Millage illimité',
    non_refundable: 'Non remboursable',
    free_cancellation_until: 'Annulation gratuite jusqu\'au {date}',
    cancellation_with_terms: 'Annulation {0} conforme aux ',
    t_c_text: 'Conditions d\'utilisation',
    two_free_extras: 'Deux suppléments gratuits à la récupération',
    glass_tyres_covered: 'Vitres et pneus couverts'
}
